import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "", as = "div" }) => {
    const Tag = motion[as] || motion.div;
    return (
        <Tag
            className={className}
            initial={{ opacity: 0, y: 32 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-70px" }}
            transition={{ duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] }}
        >
            {children}
        </Tag>
    );
};

export const Eyebrow = ({ children, dark = false }) => (
    <p
        className={`font-mono text-xs uppercase tracking-[0.3em] ${
            dark ? "text-heritage-gold" : "text-heritage-terra"
        }`}
    >
        {children}
    </p>
);
